import React, { useState, useEffect, useRef } from "react";
import { 
  useAdminLoginMutation,
  useEnable2faMutation,
  useCheck2faCodeMutation
} from "../../app/api";
import { 
  saveAdminCredentials
} from "./authSlice";
import LoginError from "./LoginError";
import {
  Container,
  Row,
  Col,
  Alert,
  Button,
  InputGroup,
  Form
} from 'react-bootstrap';
import { useGoogleLogin } from '@react-oauth/google';
//import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';



export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorStatusCode, setErrorStatusCode] = useState(undefined);
  const [isError, setIsError] = useState(false);
  const [show2FA, setShow2FA] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef([]);
  const [invalid2FA, setInvalid2FA] = useState(false);
  const [show2FAlogin, setShow2FAlogin] = useState(false);

  const [login, { isLoading, logIsError }] = useAdminLoginMutation();
  const [check2FA] = useCheck2faCodeMutation();
  const [start2FA] = useEnable2faMutation();
  
  
  const canLogin = !isLoading ;

  useEffect(() => {
     if (logIsError) {
      setIsError(true);
     } 
  }, logIsError);

  async function onLogin(code = '') {
    setErrorStatusCode(undefined);
    setIsError(false);
    try {
      if (username.includes("@alltheyears.com") || username.includes("@consultant.alltheyears.com")){
        // Submit the login attempt
        const result = await login({ username, password, 'code': code }).unwrap();

        // Reached here when the request is successful. The access token and
        // username have been updated in the local state by authSlice.

        // Save the access token and username to local storage
        if (result.permissions && result.permissions[0] == 'PENDING') {
          setErrorStatusCode(222);
        } else {
          console.log('saving auth');
          saveAdminCredentials(result.access_token, result.uuid);
        }
      }
    } catch (err) {
      // 2fa not set up
      if(err && err.status == 511){
        setShow2FA(true);
      // 2fa required
      } else if(err && err.status == 424){
        setShow2FAlogin(true);
      // other errors
      } else {
        setErrorStatusCode(err.status);
      }
    }
  }

  const handle2FACodeCheck = async (code) => {
    const res = await check2FA({'username': username, 'code': code});
    if(res.data == 'INVALID'){ setInvalid2FA(true) }
    if(res.data == 'OK'){ onLogin(code) }
  }

  const enable2FA = async () => {
    const res = await start2FA({'username': username});
    if (res.data?.qr_code) {
        setQrCode(res.data);
    }
  }

  useEffect(() => {
    if ((show2FA && qrCode) || show2FAlogin) {
      setTimeout(() => inputRefs.current[0]?.focus(), 50);
    }
  }, [show2FA, qrCode, show2FAlogin]);

  const handle2FACODEChange = (index, value) => {
    setInvalid2FA(false);
    if (!/^\d*$/.test(value)) return; // only numbers
    const newCode = [...code];
    newCode[index] = value.slice(-1);
    setCode(newCode);
    // Auto jump to next
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
    // Get full code when complete
    if (newCode.every(digit => digit)) {
      const fullCode = newCode.join('');
      handle2FACodeCheck(fullCode);
    }
  }

  const handle2FAKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  }

  // GOOGLE LOG IN
  const [ user, setUser ] = useState(null);
  const [ profile, setProfile ] = useState([]);

  const loginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log('Login Failed:', error)
  });

  useEffect(
      () => {
          if (user) {
              axios
                  .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
                      headers: {
                          Authorization: `Bearer ${user.access_token}`,
                          Accept: 'application/json'
                      }
                  })
                  .then((res) => {
                      setProfile(res.data);
                  })
                  .catch((err) => console.log(err));
          }
      },
      [ user ]
  );

  useEffect( () => {
    if (profile.hd) {
      console.log('profile hd is', profile.hd, profile);
      if (profile.hd != 'alltheyears.com' && profile.hd != 'consultant.alltheyears.com'){
        setIsError(true);
        setErrorStatusCode(223);
      }
      else {
        setUsername(profile.email);
        setPassword(profile.id);
      }
    }
  }, [ profile ])

  useEffect( () => {
    if (username && password) {
      onLogin();
    }
  }, [username, password])

  const [copied, setCopied] = useState(false);

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Container  id = 'auth' className=''>
      <Row>
        <Col className='text-center w-100 mt-5 mb-5'>
          <h1 className='fs-1 fw-bold mt-2'>Alltheyears</h1>
          {isLoading && <div className="spinner-border" role="status"><span className="sr-only"/></div>}
          <h3 className='grey fs-5 mt-1'>{!isLoading && "LOG IN"}</h3>
        </Col>
      </Row>
      {(isError || errorStatusCode) &&  (
        <LoginError className='red' errorStatusCode={errorStatusCode} />
      )}
      { !show2FA && !show2FAlogin &&
      <Row className='justify-content-sm-center flex-fill gy-5'>
        <Col className='text-center w-100'>
          <div className="d-grid gap-2">
            {!isLoading && <Button onClick={()=> {loginWithGoogle(); setIsError(false);}} disabled={!canLogin} className='mt-2 ' as="input" type="submit" value="Log In With Google" size="lg"/>}
          </div>
        </Col>
      </Row>
      }
      { show2FA && 
      <Row className='justify-content-sm-center flex-fill gy-5'>
        <Col className='text-center w-100'>
          <div className="d-grid gap-2">
            <h3>{username}</h3>
            { !qrCode &&
              <>
                <p>You must configure Two Factor Authentication to continue.</p>
                <Button onClick={()=> {enable2FA()}} className='mt-2' as="input" type="submit" value="Setup 2FA" size="lg"/>
              </>
            }
            { qrCode &&
              <div>
                  <img src={qrCode.qr_code} alt="2FA QR Code" style={{maxWidth:'450px'}} />
                  
                  <InputGroup className="mb-4">
                    <Button variant="outline-secondary" onClick={()=>handleCopy(qrCode.uri)}>
                      {copied ? 'Copied!' : 'Copy'}
                    </Button>
                    <Form.Control
                      type="text"
                      value={qrCode.uri}
                      disabled
                      readOnly
                    />
                  </InputGroup>
                  <Alert variant="info">Scan this QR code with your authenticator app or use the provided URL</Alert>

                  <p>Input your six digit authenticator code to verify.</p>
                  <div className="d-flex gap-3 justify-content-center">
                  {code.map((digit, index) => (
                    <input
                      key={index}
                      ref={el => inputRefs.current[index] = el}
                      type="text"
                      className="form-control text-center"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handle2FACODEChange(index, e.target.value)}
                      onKeyDown={(e) => handle2FAKeyDown(index, e)}
                      style={{
                        width: '60px',
                        height: '70px',
                        fontSize: '32px',
                        fontWeight: '600',
                        borderRadius: '12px',
                        border: '2px solid #dee2e6',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                      }}
                    />
                  ))}
                  </div>
                  {invalid2FA &&
                    <div className="my-3">
                      <Alert variant='danger'>
                        INVALID AUTHENTICATOR CODE
                      </Alert>
                    </div>
                  }
              </div>
            }
          </div>
        </Col>
      </Row>
      }
      { show2FAlogin && 
        <Row className='justify-content-sm-center flex-fill gy-5'>
          <Col className='text-center w-100'>
            <div className="d-grid gap-2">
              <h3>{username}</h3>
                <div>
                    <p>Input your six digit authenticator for Alltheyears.</p>
                    <div className="d-flex gap-3 justify-content-center">
                    {code.map((digit, index) => (
                      <input
                        key={index}
                        ref={el => inputRefs.current[index] = el}
                        type="text"
                        className="form-control text-center"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handle2FACODEChange(index, e.target.value)}
                        onKeyDown={(e) => handle2FAKeyDown(index, e)}
                        style={{
                          width: '60px',
                          height: '70px',
                          fontSize: '32px',
                          fontWeight: '600',
                          borderRadius: '12px',
                          border: '2px solid #dee2e6',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                      />
                    ))}
                    </div>
                    {invalid2FA &&
                      <div className="my-3">
                        <Alert variant='danger'>
                          INVALID AUTHENTICATOR CODE
                        </Alert>
                      </div>
                    }
                </div>
            </div>
          </Col>
        </Row>
      }
    </Container>

  );
}
